var _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdieinline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "wing-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "backFeet",
    style: {
      fill: "#E4BEBD"
    },
    d: "M183,236.9l8.9,5c0,0,0.5,7.9,10.5,16.7c9.7,8.6,13.2,9.8,17.7,8.9s6.9-7,6.9-7 s-6.5,2.2-10.2-0.2c-3.4-2.2-12.5-7.5-13.3-11s0.3-6.6,0.3-6.6s2.8-1.2,7.4,0.8c4.6,2,3.2,5.3,3.2,5.3s3.5-5.6,1.2-7.7 c-2.4-2.1-9.1-7.8-14.8-6.9c-5.7,0.9-7.3,1.7-7.3,1.7l-9.6-6.4L183,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "backLeg",
    style: {
      fill: "#CEC1A3"
    },
    d: "M161,231.7c0,0,3.1,3.2,8.9,4.4c5.8,1.2,13.6,1.5,13.6,1.5l3.1-4.7 c0,0-7.2-6.4-12.8-7.3C168.1,224.7,161,231.7,161,231.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backWing_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -799.8713,
    y1: 1278.0839,
    x2: -676.9227,
    y2: 1156.0538,
    gradientTransform: "matrix(0.7045 -0.7098 0.7098 0.7045 -245.2902 -1268.9197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001198948,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07332816,
    style: {
      stopColor: "#C2AB9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1889,
    style: {
      stopColor: "#B4908F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    style: {
      stopColor: "#AA7C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    style: {
      stopColor: "#A36D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#9E637D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7577,
    style: {
      stopColor: "#9B5C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "backWing",
    style: {
      fill: "url(#backWing_2_)"
    },
    d: "M93.9,197.9c-16.5-12.6-36.4-56.1-37.7-63c-1.3-6.9-1-28.4,4.6-52.6 S88.1,26,88.1,26s27.6,27.2,32.9,45.4c8,27.6-4.7,48.7-4.7,48.7s15.4,14.7,20.5,28.8c5.3,14.6,5.5,26,2.3,32.9 S102.4,203.8,93.9,197.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "body_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.3621,
    y1: 1218.4207,
    x2: 166.3621,
    y2: 1153.6523,
    gradientTransform: "matrix(1 0 0 1 0 -980)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001198948,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002093196,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2027,
    style: {
      stopColor: "#E2D5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#F1E4BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    style: {
      stopColor: "#FCEDC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "body",
    style: {
      fill: "url(#body_2_)"
    },
    d: "M48.4,203.8c0,0-5.6-32.6,67.9-30c56.9,2,58.8,17.3,77.1,23.1 c18.4,5.8,87.2-9.8,87.2-9.8s8.6,6.1,0,17.7c-8.6,11.6-32.1,18.7-32.1,18.7s-38.2-6.7-48.6-5.9s-34.9,16.1-58.8,18.9 C116.3,239.3,48.4,244.8,48.4,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "frontFeet",
    style: {
      fill: "#FBCCCC"
    },
    d: "M193.6,235.1l8.6,5.4c0,0,0.1,7.9,9.6,17.3c9.3,9.1,12.7,10.4,17.2,9.8 s7.3-6.6,7.3-6.6s-6.6,1.8-10.2-0.8c-3.3-2.4-12.1-8.2-12.7-11.7c-0.6-3.5,0.7-6.6,0.7-6.6s2.8-1.1,7.3,1.2s2.9,5.4,2.9,5.4 s3.8-5.4,1.6-7.7s-8.6-8.3-14.4-7.7c-5.8,0.6-7.4,1.3-7.4,1.3l-9.3-6.9L193.6,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "frontLeg",
    style: {
      fill: "#EADEBB"
    },
    d: "M172.3,227c0,0,3,4.4,9.3,6.6c6.3,2.2,14.9,3.6,14.9,3.6l4.1-5.6c0,0-7.1-9-13.2-10.8 C181.3,219,172.3,227,172.3,227z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frontWing_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.1547,
    y1: 1179.2344,
    x2: 177.1547,
    y2: 1033,
    gradientTransform: "matrix(1 0 0 1 0 -980)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001198948,
    style: {
      stopColor: "#FFF2CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06281341,
    style: {
      stopColor: "#E8D2BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1593,
    style: {
      stopColor: "#D0ADA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2626,
    style: {
      stopColor: "#BD9196"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    style: {
      stopColor: "#B07C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    style: {
      stopColor: "#A66D83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6201,
    style: {
      stopColor: "#9F637E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#9C5C7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "frontWing",
    style: {
      fill: "url(#frontWing_2_)"
    },
    d: "M118.3,178.2c-2.7-20.6,14.2-65.3,18.1-71.1c3.9-5.8,19.4-20.6,40.5-33.8 S236.3,53,236.3,53s0.1,38.7-9.1,55.3c-13.9,25.2-37.9,30.9-37.9,30.9s0.4,21.2-6.1,34.9c-6.7,14.1-14.6,22.2-21.7,24.8 S120.1,188.4,118.3,178.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "head",
    style: {
      fill: "#DA8483"
    },
    d: "M92.6,173.7c7.3,0,24.2,3.2,23.7,30.8c-0.5,27.8-21.5,32.2-21.5,32.2s-12.7,4.7-36.2-8.7 s-30.2-15.4-30.8-28.8C27.1,185.8,85.3,173.7,92.6,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beak",
    style: {
      fill: "#FFDE8D"
    },
    d: "M35.8,211.7c0,0,2.6-1.2,2.3-6.1c-0.4-4.9-4.1-6.4-7.2-6.4s-8.3,0.7-11.7,6.4 s6.4,13.3,6.4,13.3s-5.9-9.5,2.2-8.3L35.8,211.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_1_"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "eye",
    cx: 47.4,
    cy: 198.5,
    r: 5.8
  })), /*#__PURE__*/React.createElement("circle", {
    id: "eyeShine",
    style: {
      fill: "#FFFFFF"
    },
    cx: 46.2,
    cy: 196.6,
    r: 1.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wing-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "backFeet_1_",
    style: {
      fill: "#E4BEBD"
    },
    d: "M183,236.9l8.9,5c0,0,0.5,7.9,10.5,16.7c9.7,8.6,13.2,9.8,17.7,8.9s6.9-7,6.9-7 s-6.5,2.2-10.2-0.2c-3.4-2.2-12.5-7.5-13.3-11s0.3-6.6,0.3-6.6s2.8-1.2,7.4,0.8c4.6,2,3.2,5.3,3.2,5.3s3.5-5.6,1.2-7.7 c-2.4-2.1-9.1-7.8-14.8-6.9c-5.7,0.9-7.3,1.7-7.3,1.7l-9.6-6.4L183,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "backLeg_1_",
    style: {
      fill: "#CEC1A3"
    },
    d: "M161,231.7c0,0,3.1,3.2,8.9,4.4c5.8,1.2,13.6,1.5,13.6,1.5l3.1-4.7 c0,0-7.2-6.4-12.8-7.3C168.1,224.7,161,231.7,161,231.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backWing_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -477.082,
    y1: -562.4611,
    x2: -354.1643,
    y2: -440.4617,
    gradientTransform: "matrix(-0.8926 0.2997 -0.4121 -0.8456 -493.7043 -132.8573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001198948,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07332816,
    style: {
      stopColor: "#C2AB9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1889,
    style: {
      stopColor: "#B4908F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    style: {
      stopColor: "#AA7C87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    style: {
      stopColor: "#A36D81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#9E637D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7577,
    style: {
      stopColor: "#9B5C7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "backWing_1_",
    style: {
      fill: "url(#backWing_3_)"
    },
    d: "M164.2,195.6c-6.1-18.2-39.6-51-45.5-54.7s-25.9-11.7-50.1-16.4 c-24.2-4.7-61.2,0.6-61.2,0.6s15.8,32.8,30.9,44.1c22.8,17,46.5,14.8,46.5,14.8s8.4,18.1,19.7,27.7c11.7,9.9,22.2,14.4,29.6,14.5 C141.6,226.2,166.8,204.8,164.2,195.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "body_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.3621,
    y1: 1218.4207,
    x2: 166.3621,
    y2: 1153.6523,
    gradientTransform: "matrix(1 0 0 1 0 -980)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001198948,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002093196,
    style: {
      stopColor: "#CEC1A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2027,
    style: {
      stopColor: "#E2D5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#F1E4BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6661,
    style: {
      stopColor: "#FCEDC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1C9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "body_1_",
    style: {
      fill: "url(#body_3_)"
    },
    d: "M48.4,203.8c0,0-5.6-32.6,67.9-30c56.9,2,58.8,17.3,77.1,23.1 c18.4,5.8,87.2-9.8,87.2-9.8s8.6,6.1,0,17.7c-8.6,11.6-32.1,18.7-32.1,18.7s-38.2-6.7-48.6-5.9s-34.9,16.1-58.8,18.9 C116.3,239.3,48.4,244.8,48.4,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "frontFeet_1_",
    style: {
      fill: "#FBCCCC"
    },
    d: "M193.6,235.1l8.6,5.4c0,0,0.1,7.9,9.6,17.3c9.3,9.1,12.7,10.4,17.2,9.8 s7.3-6.6,7.3-6.6s-6.6,1.8-10.2-0.8c-3.3-2.4-12.1-8.2-12.7-11.7c-0.6-3.5,0.7-6.6,0.7-6.6s2.8-1.1,7.3,1.2s2.9,5.4,2.9,5.4 s3.8-5.4,1.6-7.7s-8.6-8.3-14.4-7.7c-5.8,0.6-7.4,1.3-7.4,1.3l-9.3-6.9L193.6,235.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "frontLeg_1_",
    style: {
      fill: "#EADEBB"
    },
    d: "M172.3,227c0,0,3,4.4,9.3,6.6c6.3,2.2,14.9,3.6,14.9,3.6l4.1-5.6 c0,0-7.1-9-13.2-10.8C181.3,219,172.3,227,172.3,227z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frontWing_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.9012,
    y1: -35.4442,
    x2: 489.9012,
    y2: 110.7299,
    gradientTransform: "matrix(0.6916 0.7223 0.7223 -0.6916 -168.0058 -146.3008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001198948,
    style: {
      stopColor: "#FFF2CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06281341,
    style: {
      stopColor: "#E8D2BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1593,
    style: {
      stopColor: "#D0ADA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2626,
    style: {
      stopColor: "#BD9196"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    style: {
      stopColor: "#B07C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    style: {
      stopColor: "#A66D83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6201,
    style: {
      stopColor: "#9F637E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#9C5C7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A5A7A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "frontWing_1_",
    style: {
      fill: "url(#frontWing_3_)"
    },
    d: "M119.7,175c13-16.2,57-34.9,63.9-36.1c6.9-1.2,28.3-0.2,52.4,5.9 c24.1,6.1,55.7,28.9,55.7,28.9s-27.9,26.8-46.2,31.7c-27.8,7.4-48.5-6-48.5-6s-15,14.9-29.4,19.7c-14.8,4.9-26.1,4.8-32.9,1.5 S113.6,183.4,119.7,175z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "head_1_",
    style: {
      fill: "#DA8483"
    },
    d: "M92.6,173.7c7.3,0,24.2,3.2,23.7,30.8c-0.5,27.8-21.5,32.2-21.5,32.2 s-12.7,4.7-36.2-8.7s-30.2-15.4-30.8-28.8C27.1,185.8,85.3,173.7,92.6,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beak_1_",
    style: {
      fill: "#FFDE8D"
    },
    d: "M35.8,211.7c0,0,2.6-1.2,2.3-6.1c-0.4-4.9-4.1-6.4-7.2-6.4s-8.3,0.7-11.7,6.4 s6.4,13.3,6.4,13.3s-5.9-9.5,2.2-8.3L35.8,211.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_2_"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "eye_3_",
    cx: 47.4,
    cy: 198.5,
    r: 5.8
  })), /*#__PURE__*/React.createElement("circle", {
    id: "eyeShine_1_",
    style: {
      fill: "#FFFFFF"
    },
    cx: 46.2,
    cy: 196.6,
    r: 1.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdieinline);
export default __webpack_public_path__ + "static/media/birdie.inline.80ab4cf5ae5b842790d8b9ca778c20b9.svg";
export { ForwardRef as ReactComponent };